export default __webpack_public_path__ + "static/media/negativeLogo.55458007.svg";